import ServiceBase from "base/baseService"

export default class FuncaoParticipanteService extends ServiceBase {

    title = "Função de participante"
    pluralTitle = "Funções de participantes"
    url = '/cadastro/fiscal/funcaoparticipante'
    frontUrl = '/cadastro/fiscal/funcaoparticipante'
    frontUrlList = '/cadastro/fiscal/funcaoparticipantelist'
    primaryKey = 'codigo_fupar'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar Switch (Se não permite null?)

        // Se usar checkbox (Se permite null?)

        // Numéricos com FK notNullable

        // Strings notNullable

        data.descricao_fupar = data?.descricao_fupar || ''

        // Numéricos sem FK

        // Dependentes

        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie
        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie
        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie
        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie
        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie
        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie

        // Datas

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
